// useAiFeedReadSync.js — mark linked notifications read when Ai feed is viewed

import { useEffect, useRef } from 'react';

import { MESSAGE_TYPES } from 'spaces/constants/aiConstants';
import { markNotificationsAsRead } from 'services/notifications/NotificationService';

function collectUnreadFeedNotificationKeys(messages = []) {
  const keys = new Set();

  (Array.isArray(messages) ? messages : []).forEach((message) => {
    if (String(message?.messageType || '').trim() !== MESSAGE_TYPES.AI_FEED_ITEM) return;

    const feed = message?.feed && typeof message.feed === 'object' ? message.feed : null;
    if (!feed || feed.readAt) return;

    const listedKeys = Array.isArray(feed.notificationKeys)
      ? feed.notificationKeys
      : [];
    listedKeys.forEach((key) => {
      const cleanKey = String(key || '').trim();
      if (cleanKey) keys.add(cleanKey);
    });

    const singleKey = String(feed.notificationKey || '').trim();
    if (singleKey) keys.add(singleKey);
  });

  return [...keys];
}

export default function useAiFeedReadSync({
  enabled = false,
  messages = [],
} = {}) {
  const markedKeysRef = useRef(new Set());

  useEffect(() => {
    if (!enabled) return;

    const pendingKeys = collectUnreadFeedNotificationKeys(messages)
      .filter((key) => !markedKeysRef.current.has(key));

    if (!pendingKeys.length) return;

    pendingKeys.forEach((key) => markedKeysRef.current.add(key));

    markNotificationsAsRead(pendingKeys).catch((error) => {
      pendingKeys.forEach((key) => markedKeysRef.current.delete(key));
      console.error('[useAiFeedReadSync] mark notifications read failed:', error);
    });
  }, [enabled, messages]);
}
